import { nombreEnTexte } from './nombre.js';

/**
 * LES TEMPS ET LES TEXTES DU DOSSIER D'UN ANIMAL, purs : aucun React, aucun
 * SDK, testes par `temps.test.mjs`. Tout se calcule en heure
 * LOCALE, jamais par `toISOString`, qui ferait glisser le jour d'un fuseau a
 * l'autre.
 */
const JOURS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

/** Les deux instants tombent-ils le meme jour, en heure locale ? */
export function estLeJour(instant: Date, jour: Date): boolean {
  return (
    instant.getFullYear() === jour.getFullYear() &&
    instant.getMonth() === jour.getMonth() &&
    instant.getDate() === jour.getDate()
  );
}

/** « Mardi 20 octobre ». */
export function libelleDuJour(jour: Date): string {
  return `${JOURS[jour.getDay()]} ${jour.getDate()} ${MOIS[jour.getMonth()]}`;
}

/** « 09:05 ». */
export function heureDe(instant: Date): string {
  return `${String(instant.getHours()).padStart(2, '0')}:${String(instant.getMinutes()).padStart(2, '0')}`;
}

/** Le jour d'un instant en date PURE `YYYY-MM-DD`, locale. */
export function jourPur(instant: Date): string {
  return `${instant.getFullYear()}-${String(instant.getMonth() + 1).padStart(2, '0')}-${String(instant.getDate()).padStart(2, '0')}`;
}

/**
 * L'AGE DE L'ANIMAL AU JOUR DE LA CONSULTATION (« 6 ans 4 mois », comme Fuga),
 * depuis une naissance en date pure. Vide si la naissance manque ou est fausse.
 */
export function ageAuJour(naissance: unknown, jour: Date): string {
  if (typeof naissance !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(naissance)) return '';
  const annee = Number(naissance.slice(0, 4));
  const mois = Number(naissance.slice(5, 7)) - 1;
  const date = Number(naissance.slice(8, 10));
  let totalMois = (jour.getFullYear() - annee) * 12 + (jour.getMonth() - mois);
  if (jour.getDate() < date) totalMois -= 1;
  if (totalMois < 0) return '';
  const ans = Math.floor(totalMois / 12);
  const reste = totalMois % 12;
  if (ans === 0) return `${reste} mois`;
  const motAn = ans > 1 ? 'ans' : 'an';
  return reste === 0 ? `${ans} ${motAn}` : `${ans} ${motAn} ${reste} mois`;
}

/** Une valeur du sac en texte : un tableau se joint, l'absence est vide. */
export function valeurEnTexte(valeur: unknown): string {
  if (Array.isArray(valeur)) return valeur.map(String).join(', ');
  if (typeof valeur === 'string') return valeur;
  if (typeof valeur === 'number') return nombreEnTexte(valeur);
  return '';
}


/** Une date pure `YYYY-MM-DD` en « 20/10/2026 » ; vide si mal formee. */
export function datePureEnTexte(valeur: unknown): string {
  if (typeof valeur !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(valeur)) return '';
  return `${valeur.slice(8, 10)}/${valeur.slice(5, 7)}/${valeur.slice(0, 4)}`;
}
